import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from "mobx-react";

import { StepperTemplate } from 'themes/components';

@observer
class Stepper extends Component {
    render() {
        return (
            <StepperTemplate {...this.props} store={this.props.store} />
        );
    }
}

Stepper.propTypes = {
    store: PropTypes.object.isRequired
};

export default Stepper;
